/**
 * Created by wangjianglong on 20190829.
 */
import Vue from 'vue' ;
let bus = new Vue();
export default bus;



// WEBPACK FOOTER //
// ./src/bus/bus.js